export default class Money {
  #value;
  #currency;

  get value() {
    return this.#value;
  }
  set value(val) {
    this.#value = val;
  }

  get currency() {
    return this.#currency;
  }

  constructor(currency) {
    this.#currency = currency;
  }

  getDisplayString() {
    const displayString = this.#value.toLocaleString("en-GB", { style: "currency", currency: this.#currency.isoCode });
    // Remove trailing zeroes if a round number
    return displayString.replace(".00", "");
  }
}